import api from "../../fetch/surveyApi";
import * as types from "../types";

const state = {
  surveyInfo: JSON.parse(sessionStorage.getItem("surveyInfo")) || {},
  pageIndex: 0,
  questions: JSON.parse(sessionStorage.getItem("surveyQuestions")) || [],
  answers: JSON.parse(sessionStorage.getItem("surveyAnswers")) || []
};

const getters = {
  surveyDetail: state => state.surveyInfo,
  surveyPageIndex: state => state.pageIndex,
  surveyPageCount: state => Math.max.apply(Math,state.questions.map(x=>x.pageIndex))+1,
  surveyQuesCount: state => state.questions.length,
  surveyQuesCurrent: state => state.questions.filter(x=>x.pageIndex==state.pageIndex),
  surveyAnswers:state=>state.answers
};

const mutations = {
  [types.GET_SURVEY](state, res) {
    state.surveyInfo = res;
  },
  [types.SET_SURVEY_PAGE_INDEX](state, res) {
    state.pageIndex = res;
  },
  [types.SET_SURVEY_QUESTIONS](state, res) {
    state.questions = res;
  },
  [types.SET_SURVEY_ANSWERS](state, res) {
    state.answers = res;
  },
  [types.SET_SURVEY_PAGE_NEXT](state, res) {
    if(state.pageIndex<state.questions.length-1){
      state.pageIndex++;
    }
   
  },
  [types.SET_SURVEY_PAGE_PREVIOUS](state, res) {
    if(state.pageIndex>0){
      state.pageIndex--;
    }
  },
};
const actions = {
  getSurvey({ commit }) {
    api.getSurvey().then(re => {
      console.log(re);
      let surveyName = re.surveyName;
      let surveyID = re.id;
      let surveyNote = re.surveyDetail.surveyNote;

      let qus = re.questions;
      let questions = [];
      let answers=[];
      let pIndex = 0;
      let quIndex=0;
      qus.forEach(el => {
        let radios = el.quRadios.map(v => {
          return {
            id: v.id,
            quId: v.quId,
            optionName: v.optionName,
            checkType: v.checkType,
            orderById: v.orderById,
            visibility: v.visibility
          };
        });
        let checkboxes = el.quCheckboxs.map(v => {
          return {
            id: v.id,
            quId: v.quId,
            optionName: v.optionName,
            checkType: v.checkType,
            orderById: v.orderById,
            visibility: v.visibility
          };
        });
        if (el.quType == "PAGETAG") {
          pIndex++;
        } else {
          questions.push({
            quIndex:quIndex,
            pageIndex: pIndex,
            quId: el.id,
            quTitle: el.quTitle,
            quType: el.quType,
            isRequired: el.isRequired,
            quRadios: radios,
            quCheckboxs: checkboxes
          });
          quIndex++;
          if(el.quType == "CHECKBOX"){
            answers.push({ quId: el.id,quType: el.quType,answer:[]});
          }else{
            answers.push({ quId: el.id,quType: el.quType,answer:null});
          }
          
        }
      });
    
      commit(types.GET_SURVEY, {surveyName:surveyName,surveyID:surveyID,surveyNote:surveyNote});
      commit(types.SET_SURVEY_QUESTIONS, questions);
      commit(types.SET_SURVEY_ANSWERS, answers);
      
    });
  }
};

export default{
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/survey.js